/* ABB 16 Oct 2026 gift-fix3 (preview only). Add-on to cart.js / cart-drawer.js; neither is edited.
   Rule: a free gift and a discount code never go together, and no line labelled Free Gift is ever charged.
   1) Gift-card product 15410187272275 doesn't count toward gift tiers (checkout's BXGY ignores it).
   2) Any gift line (_gift=true, or product tagged free-gift) that isn't $0 after discounts is removed,
      except a partial T2/T3 claim (gift count < tiers unlocked, no code), which is kept while the customer picks.
   3) Checkout buttons are intercepted: a code on the cart removes all gifts; a partial claim asks the customer to
      pick the rest (OK) or removes the unpaid gift(s) (Cancel). Express buttons on /cart are disabled while
      a priced gift is in the cart.
   Rollback: delete the <script> tag for this file in snippets/cart-drawer.liquid. */
(function () {
  if (window.__abbGiftFix3) return;
  window.__abbGiftFix3 = true;
  var GIFT_CARD_PRODUCTS = [15410187272275];
  var TAG_RE = /^free[- ]?gift$/i;
  var tagCache = {};
  var busy = null;

  function isGiftCardLine(i) { return !!i && (i.gift_card === true || GIFT_CARD_PRODUCTS.indexOf(Number(i.product_id)) > -1); }
  function isGiftProp(i) { var p = (i && i.properties) || {}; return String(p._gift) === "true" || String(p.__upez_free_gift) === "true"; }
  function tiers() { var t = window.cartGiftTiers || {}; return [Number(t["1"]) || 0, Number(t["2"]) || 0, Number(t["3"]) || 0]; }
  function eligibleTotal(cart) {
    return (cart.items || []).reduce(function (s, i) {
      if (isGiftProp(i) || i.selling_plan_allocation || isGiftCardLine(i)) return s;
      return s + (Number(i.final_line_price) || 0);
    }, 0);
  }
  function tags(handle) {
    if (!handle) return Promise.resolve([]);
    if (!tagCache[handle]) tagCache[handle] = fetch("/products/" + encodeURIComponent(handle) + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; }).then(function (p) { return (p && p.tags) || []; }).catch(function () { return []; });
    return tagCache[handle];
  }
  function getCart() { return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }); }
  function drawer() { return document.querySelector("cart-drawer"); }
  function codes(cart) {
    var d = drawer();
    if (d && d.getCustomerPromoCodes) return d.getCustomerPromoCodes(cart);
    return (cart.discount_codes || []).filter(function (c) { return c && c.applicable !== false; }).map(function (c) { return c.code || c; });
  }

  // Fix 1: JS-side eligible total (drives removeIneligibleGifts) excludes the gift-card product.
  customElements.whenDefined("cart-items").then(function () {
    var C = customElements.get("cart-items"); if (!C || C.prototype.__abbFix3) return;
    C.prototype.__abbFix3 = true;
    var orig = C.prototype.getEligibleCartTotal;
    C.prototype.getEligibleCartTotal = function (cart) {
      var base = orig ? orig.call(this, cart) : 0;
      return Math.max(0, base - (cart && cart.items || []).reduce(function (s, i) {
        return s + (isGiftCardLine(i) && !isGiftProp(i) && !i.selling_plan_allocation ? Number(i.final_line_price) || 0 : 0);
      }, 0));
    };
  });

  async function analyse(cart) {
    var gifts = [];
    await Promise.all((cart.items || []).map(async function (i) {
      if (isGiftProp(i)) { gifts.push(i); return; }
      var t = await tags(i.handle);
      if (t.some(function (x) { return TAG_RE.test(String(x).trim()); })) gifts.push(i);
    }));
    var tot = eligibleTotal(cart), th = tiers();
    var unlocked = th.filter(function (v) { return v > 0 && tot >= v; }).length;
    var claimed = gifts.filter(isGiftProp).reduce(function (s, i) { return s + i.quantity; }, 0);
    var priced = gifts.filter(function (i) { return Number(i.final_line_price) > 0; });
    var hasCode = codes(cart).length > 0;
    // Partial claim: a T2/T3 gift is unpaid only because not all gifts are picked yet.
    var partial = !hasCode && priced.length > 0 && unlocked >= 2 && claimed < unlocked &&
      priced.every(function (i) { return isGiftProp(i) && i.quantity === 1; });
    return { gifts: gifts, priced: priced, hasCode: hasCode, partial: partial, unlocked: unlocked, claimed: claimed };
  }

  async function removeLines(lines) {
    var updates = {}; lines.forEach(function (i) { updates[i.key] = 0; });
    if (!Object.keys(updates).length) return;
    await fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ updates: updates }) });
  }

  async function rerender() {
    var d = drawer();
    try {
      if (document.querySelector("cart-items") && !document.querySelector("cart-drawer.active") && location.pathname.replace(/\/$/, "").endsWith("/cart")) { location.reload(); return; }
      if (d && d.fetchCartDrawerSections && d.renderContents) {
        var s = await d.fetchCartDrawerSections(); if (s) { d.renderContents(s); var c = await getCart(); d.classList.toggle("is-empty", c.item_count === 0); }
      }
    } catch (e) { console.warn("abb gift-fix3 rerender", e); }
  }

  function setNote(a) {
    var msg = a && a.partial ? "You've picked " + a.claimed + " of " + a.unlocked + " free gifts. Pick " + (a.unlocked - a.claimed) +
      " more to make them free. Unpaid gifts are removed at checkout." : "";
    document.querySelectorAll("[data-abb-fix3-note]").forEach(function (n) { if (!msg) n.remove(); else n.textContent = msg; });
    if (msg) {
      document.querySelectorAll("cart-drawer .drawer__footer, .cart__footer .cart__blocks").forEach(function (f) {
        if (f.querySelector("[data-abb-fix3-note]")) return;
        var p = document.createElement("p"); p.setAttribute("data-abb-fix3-note", ""); p.setAttribute("role", "status");
        p.style.cssText = "margin:0 0 1rem;font-size:1.25rem;color:#3f4145"; p.textContent = msg; f.prepend(p);
      });
    }
    document.querySelectorAll(".additional-checkout-buttons, shopify-accelerated-checkout-cart").forEach(function (b) {
      b.style.pointerEvents = msg ? "none" : ""; b.style.opacity = msg ? "0.4" : ""; b.setAttribute("aria-disabled", msg ? "true" : "false");
    });
  }

  // Enforce the rule. atCheckout: resolve partial claims too. Returns false if the customer chose to keep picking.
  async function enforce(atCheckout) {
    if (busy) return busy;
    busy = (async function () {
      var changed = false, a;
      for (var n = 0; n < 4; n++) {
        var cart = await getCart(); a = await analyse(cart);
        var drop = [];
        if (a.hasCode) drop = a.gifts;
        else if (a.priced.length && !a.partial) drop = a.priced;
        else if (a.partial && atCheckout) {
          var left = a.unlocked - a.claimed;
          var pick = window.confirm("Your free gifts are only free once you've picked all " + a.unlocked + " (you've picked " + a.claimed +
            "). OK: pick " + left + " more now. Cancel: remove the unpaid gift" + (a.priced.length > 1 ? "s" : "") + " and continue to checkout.");
          if (pick) {
            var d = drawer(); setNote(a);
            if (d) { if (!d.classList.contains("active") && d.open) d.open(); setTimeout(function () { d.openGiftPanel && d.openGiftPanel(); }, 400); }
            else location.href = "/cart";
            return false;
          }
          drop = a.priced;
        }
        if (!drop.length) break;
        await removeLines(drop); changed = true;
      }
      if (changed) { a = await analyse(await getCart()); await rerender(); }
      setNote(a);
      return true;
    })();
    try { return await busy; } finally { busy = null; }
  }
  window.abbGiftEnforce = enforce;

  // Checkout interception (capture phase, runs before the theme's own handlers).
  var SEL = '#CartDrawer-Checkout, button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]';
  var going = false;
  async function goCheckout(ev, el) {
    if (going) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    going = true; if (el) el.setAttribute("aria-busy", "true");
    try {
      var ok = await enforce(true);
      if (ok) { location.href = "/checkout"; return; }
    } catch (e) { console.error("abb gift-fix3", e); location.href = "/checkout"; return; }
    going = false; if (el) el.removeAttribute("aria-busy");
  }
  window.addEventListener("click", function (ev) {
    var el = ev.target instanceof Element ? ev.target.closest(SEL) : null;
    if (el && !el.disabled) goCheckout(ev, el);
  }, true);
  window.addEventListener("submit", function (ev) {
    var s = ev.submitter;
    if (s && s.name === "checkout") goCheckout(ev, s);
  }, true);

  // Run on load, after cart updates, on drawer open, on bfcache restore / tab refocus.
  var t = null;
  function soon(ms) { clearTimeout(t); t = setTimeout(function () { enforce(false).catch(function (e) { console.warn(e); }); }, ms || 1200); }
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") subscribe(PUB_SUB_EVENTS.cartUpdate, function () { soon(1500); });
  customElements.whenDefined("cart-drawer").then(function () {
    var C = customElements.get("cart-drawer");
    if (C && !C.prototype.__abbFix3Open) {
      C.prototype.__abbFix3Open = true;
      var o = C.prototype.open; C.prototype.open = function () { var r = o.apply(this, arguments); soon(1500); return r; };
      var cg = C.prototype.claimGift; if (cg) C.prototype.claimGift = async function () { var r = await cg.apply(this, arguments); soon(800); return r; };
    }
  });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { soon(1500); }, { once: true }); else soon(1500);
  window.addEventListener("pageshow", function (e) { if (e.persisted) soon(300); });
  document.addEventListener("visibilitychange", function () { if (document.visibilityState === "visible") soon(300); });
})();
